import SEO from '../../components/SEO';
import React, { useState } from 'react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import AppointmentModal from '../../components/AppointmentModal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AngerManagementPage = () => {
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [insuranceProviders, setInsuranceProviders] = useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const insuranceRes = await axios.get(`${API}/insurance`);
        setInsuranceProviders(insuranceRes.data);
      } catch (error) {
        // Error handled silently
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Anger Management Counseling" description="Anger management therapy and counseling at SDORA Wellbeing in Pikesville, MD. Evidence-based approaches for adults and youth. In-person and telehealth. Accepting Medicaid." path="/services/anger-management" />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-red-600 to-orange-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Anger Management
          </h1>
          <p className="text-xl md:text-2xl text-red-100 max-w-3xl">
            Learn to understand and express anger in healthier, non-aggressive ways.
          </p>
        </div>
      </div>

      {/* Service Description */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">What is Anger Management?</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Anger Management helps individuals understand and express anger in healthier and non-aggressive ways. Our program provides practical strategies and techniques to manage anger constructively, helping you communicate your needs effectively while reducing the risk of harm to yourself or others.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">Benefits</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-red-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Recognize triggers and early warning signs</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-red-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Practical tools for de-escalation and self-control</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-red-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Improved communication and conflict resolution skills</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-red-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Healthier relationships and reduced legal or social consequences</span>
              </li>
            </ul>

            <button
              onClick={() => setShowAppointmentModal(true)}
              className="w-full md:w-auto bg-red-600 text-white px-8 py-4 rounded-lg hover:bg-red-700 transition-colors font-semibold text-lg"
            >
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>

      <Footer />
      
      {showAppointmentModal && (
        <AppointmentModal 
          onClose={() => setShowAppointmentModal(false)}
          insuranceProviders={insuranceProviders}
        />
      )}
    </div>
  );
};

export default AngerManagementPage;